import axios, { AxiosInstance } from "axios";

export enum ZealotCollections {
  CAMPAIGNS = "campaigns",
  FORCES = "forces",
}

class MongoService {
  private baseUrl: string = process.env.VUE_APP_FUNCTIONS_BASEURL || "";
  private axiosClient: AxiosInstance;

  constructor(token: string) {
    this.axiosClient = axios.create({
      timeout: 1000 * 9,
      baseURL: this.baseUrl,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  public async searchDocuments<T>(
    collection: string,
    filter: any = {}
  ): Promise<T[]> {
    return (
      await this.axiosClient.post("searchdocuments", filter, {
        params: {
          collection,
        },
      })
    ).data as T[];
  }

  public async insertDocument(
    collection: string,
    document: any
  ): Promise<string> {
    return (
      await this.axiosClient.post("insertdocument", document, {
        params: {
          collection,
        },
      })
    ).data;
  }

  public async findDocument<T>(collection: string, id: string): Promise<T> {
    return (
      await this.axiosClient.get("finddocument", {
        params: {
          collection,
          id,
        },
      })
    ).data;
  }

  public async replaceDocument(
    collection: string,
    id: string,
    document: any
  ): Promise<string> {
    return (
      await this.axiosClient.post("replacedocument", document, {
        params: {
          collection,
          id,
        },
      })
    ).data;
  }

  public async updateDocument<T>(
    collection: string,
    id: string,
    update: any
  ): Promise<T> {
    return (
      await this.axiosClient.post("updatedocument", update, {
        params: {
          collection,
          id,
        },
      })
    ).data;
  }

  public async deleteDocument(collection: string, id: string): Promise<void> {
    return (
      await this.axiosClient.post(
        "deletedocument",
        {},
        {
          params: {
            collection,
            id,
          },
        }
      )
    ).data;
  }
}

export default MongoService;
